import type { IconSvgObject } from './types';

const Mailbox01Icon: IconSvgObject = [
  ["path", { d: "M6.5 9H8.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17.5 8.5V4C17.5 2.89543 18.3954 2 19.5 2H20.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2.5 10C2.5 7.23858 4.73858 5 7.5 5H16.5C19.2614 5 21.5 7.23858 21.5 10V16C21.5 17.1046 20.6046 18 19.5 18H4.5C3.39543 18 2.5 17.1046 2.5 16V10Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12.5 22V10C12.5 7.23858 10.2614 5 7.5 5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Mailbox01Icon;
